import { useNavigate } from "react-router-dom";
import { Send, ShieldQuestion, Users, CreditCard, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { DashboardKPIs } from "../DashboardKPIs";
import { useAuth } from "../../context/AuthContext";

const ActionCard = ({ icon: Icon, title, text, onClick, primary = false }) => (
  <button
    onClick={onClick}
    className={`text-left rounded-2xl border p-5 transition-all hover:-translate-y-0.5 hover:shadow-sm ${primary ? "bg-emerald-500 border-emerald-500 text-emerald-950" : "bg-white border-slate-200 text-slate-900 hover:border-emerald-300"}`}
  >
    <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-4 ${primary ? "bg-white/40" : "bg-emerald-50"}`}>
      <Icon className={`w-5 h-5 ${primary ? "text-emerald-950" : "text-emerald-600"}`} />
    </div>
    <div className="font-heading font-bold text-lg">{title}</div>
    <p className={`text-sm mt-1 leading-relaxed ${primary ? "text-emerald-950/75" : "text-slate-500"}`}>{text}</p>
    <div className="mt-4 flex items-center gap-1.5 text-sm font-semibold">Ouvrir <ArrowRight className="w-4 h-4" /></div>
  </button>
);

export const ConnectedHome = () => {
  const navigate = useNavigate();
  const { user, activeWorkspace } = useAuth();
  const role = activeWorkspace?.role || "member";
  const billingOnly = role === "billing_admin";
  const name = user?.first_name || user?.name || user?.email?.split("@")[0] || "";

  return (
    <div data-testid="connected-home" className="space-y-8">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <span className="text-xs font-semibold tracking-[0.18em] uppercase text-emerald-600">Espace connecté</span>
          <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight mt-1">Bonjour{name ? ` ${name}` : ""}</h1>
          <p className="text-slate-500 mt-2">{activeWorkspace?.name ? `Vous travaillez actuellement dans ${activeWorkspace.name}.` : "Votre espace SecurePass."}</p>
        </div>
        {!billingOnly && (
          <Button onClick={() => navigate("/envoyer")} className="bg-emerald-500 hover:bg-emerald-400 text-emerald-950 font-semibold">
            <Send className="w-4 h-4 mr-2" /> Envoyer
          </Button>
        )}
      </div>

      <section>
        <h2 className="font-heading text-lg font-bold mb-3">Que souhaitez-vous faire ?</h2>
        <div className={`grid gap-4 ${billingOnly ? "sm:grid-cols-2" : "sm:grid-cols-2 xl:grid-cols-3"}`}>
          {billingOnly ? (
            <>
              <ActionCard icon={CreditCard} title="Gérer la facturation" text="Abonnement, moyens de paiement et documents de facturation." onClick={() => navigate("/compte/facturation")} primary />
              <ActionCard icon={CreditCard} title="Historique" text="Consulter l'activité accessible pour ce Workspace." onClick={() => navigate("/compte/historique")} />
            </>
          ) : (
            <>
              <ActionCard icon={Send} title="Envoyer" text="Transmettre un mot de passe, un secret ou un fichier avec les parcours SecurePass existants." onClick={() => navigate("/envoyer")} primary />
              <ActionCard icon={ShieldQuestion} title="Demander une information" text="Créer une demande sécurisée et transmettre le lien au destinataire." onClick={() => navigate("/demander")} />
              <ActionCard icon={Users} title="Ouvrir l'annuaire" text="Retrouver les contacts du Workspace avant de lancer une opération." onClick={() => navigate("/compte/annuaire")} />
            </>
          )}
        </div>
      </section>

      <section className="pt-1">
        <div className="flex items-center justify-between gap-3 mb-3">
          <h2 className="font-heading text-lg font-bold">Activité et consommation</h2>
        </div>
        <DashboardKPIs role={role} onManageSubscription={() => navigate("/compte/facturation")} />
      </section>
    </div>
  );
};
